const truncate = (input: string, limit: number) => {
  if(input){
    if (input.length <= limit) return input;
    return input.substr(0, input.lastIndexOf(' ', limit)).concat('...');
  }
};

export default truncate;
